/* eslint-disable spaced-comment */
import { HttpService } from '../../services/HttpService';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import * as Constants from './Constants';
import { apiUrls } from '../../constants/apiUrl';
import { store } from '../../configureStore';
import { getIntendType, getFlowType, maskCard, getSession, isFuncComp } from '../../components/common/Helpers/index';
import { orderNumber, locationCode, mobileNumber } from './helpers/index';

export const getPaymentOptions = (data) => ({
  type: Constants.GET_PAYMENT_OPTIONS,
  data,
});

export const postTOSSendLinkDetails = (data) => ({
  type: 'POST_SEND_LINK_DETAILS',
  data,
});

export const postTOSSendLinkDetailsAPI = (data) => HttpService.post(`/soe/digital${apiUrls().inspicioSendMessage}`, data);

export const getPaymentZipDetails = (zipCode) => ({
  type: Constants.GET_PAYMENT_ZIP_DETAILS,
  zipCode,
});

export const getPaymentZipCodeDetailsApi = ({ zipCode }) => {
  const postJSON = {
    data: {
      zipCode,
    },
  };
  return HttpService.post(`${getSecureBaseUrl()}${apiUrls().zipMarketDetailsUrl}`, postJSON);
};

export const getPaymentOptionsData = () => {
  const postData = {};

  const apiURL = `${getSecureBaseUrl()}${apiUrls().paymentInfourl}`;
  return HttpService.post(apiURL, postData);
};

/* Action to submit Form details */

export const applePayGetSession = (appleSessionObj, validationURL, url, errorMessage) => ({
  type: Constants.GET_APPLE_PAY_SESSION,
  appleSessionObj,
  validationURL,
  url,
  errorMessage,
  orderNumber,
  locationCode: `${locationCode}`,
});

export const applePayProcessSession = (appleSessionObj, paymentResponseJSON, url, successCallback = () => null, errorMessage) => ({
  type: Constants.PROCESS_APPLE_PAY_SESSION,
  appleSessionObj,
  orderNumber,
  locationCode,
  paymentResponseJSON,
  url,
  successCallback,
  errorMessage,
});

/* Paypal Login actions */

export const paypalLogin = ({ paypalLookUpUrl, triggerFrom }) => ({
  type: Constants.PAYPAL_LOGIN,
  paypalLookUpUrl: paypalLookUpUrl || '/paymentservice/doCMPILookup',
  triggerFrom,
});

export const loginPaypalAPI = (url) => {
  const intendType = `${getIntendType()}`;
  let cartId = '';
  if (getSession('cartid')) {
    cartId = getSession('cartid');
  }
  const meta = {
    cartId,
    clientId: 'VZW-DOTCOM',
    locationCode: `${locationCode}`,
    orderNumber,
    regNo: '30',
    salesRep: 'ENC',
    userId: 's3eq2w',
  };
  const meta1 = {
    locationCode: `${locationCode}`,
    orderNumber,
    regNo: '30',
    salesRep: 'ENC',
    userId: '',
  };
  const postData = intendType.includes('NSE')
    ? {
        meta: meta1,
        triggerFrom: 'CHECKOUT',
        paymentType: 'payPal',
        action: 'CMPILOOKUP',
      }
    : {
        meta,
        triggerFrom: 'express-checkout',
        paymentType: 'payPal',
        action: 'CMPILOOKUP',
      };
  const apiURL = `${getSecureBaseUrl()}${url}`;
  return HttpService.post(apiURL, postData);
};

export const confirmSubmit = (data) => ({
  type: 'ADD_CARD_DETAILS_TO_CART',
  data,
});

export const addSavedCardDetailsAPI = (data) => {
  const intendType = `${getIntendType('payment')}`;
  let postData = {};
  let paymentDetails;
  let paymentAmount;
  let profileInfo;
  let cartHeader;
  let account_No;
  let location_Code;
  let phone_No;
  let orderType;
  let orderNumberVal;

  if (isFuncComp()) {
    paymentDetails = store.getState()?.checkout?.getCheckoutResponse?.data?.payment;
    paymentAmount = paymentDetails?.orderTotal;
    profileInfo = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.lineDetails?.lineInfo?.newline1?.serviceInfo?.primaryUserInfo;
    cartHeader = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.cartHeader;
    account_No = cartHeader && cartHeader?.fullAccountNumber && cartHeader?.fullAccountNumber.split('-')[0];
    location_Code = cartHeader && cartHeader?.cartCreatorOrderLocationCode;
    phone_No = profileInfo && profileInfo?.address && profileInfo?.address?.phoneNumber;
    orderType = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.orderDetails?.orderType;
    orderNumberVal = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.orderDetails?.orderNumber;
  } else {
    paymentDetails = store.getState()?.paymentInfo?.data;
    paymentAmount = paymentDetails?.orderTotal;
    profileInfo = store.getState()?.cartDetails?.cartDetailsJson?.primaryUserInfo;
    cartHeader = store.getState()?.cartDetails?.cartDetailsJson?.cartHeader;
    account_No = cartHeader && cartHeader?.fullAccountNumber && cartHeader?.fullAccountNumber.split('-')[0];
    location_Code = cartHeader && cartHeader?.cartCreatorOrderLocationCode;
    phone_No = profileInfo && profileInfo?.address && profileInfo?.address?.phoneNumber;
    orderType = store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.orderType;
    orderNumberVal = store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.orderNumber;
  }
  postData = {
    skipCheckoutCall: true,
    accountNumber: account_No || '',
    accountSubNumber: '00001',
    action: 'lookup',
    intendType,
    locationCode: locationCode || location_Code,
    mobileNumber: mobileNumber || phone_No,
    orderNumber: orderNumberVal,
    orderType: orderType || 'PS',
    paymentData: [
      {
        paymRegisterNum: '30',
        paymentAmount,
        paymentType: 'CR',
        savedCC: true,
        creditCardPayment: {
          cardNumber: data?.savedCCList?.[0]?.creditCardNumber,
          cardExpMonth: data?.savedCCList?.[0]?.expiryMonth,
          cardExpYear: data?.savedCCList?.[0]?.expiryYear,
          encryptedCardData: '',
          encryptedCardData2: '',
          cardAddressZip: data?.savedCCList?.[0]?.zipCode,
          encryptType: 'PIE',
          creditCardType: data?.savedCCList?.[0]?.creditCardType,
          cardAdditionalInfo: {
            firstName: profileInfo?.firstName,
            midInitials: '',
            lastName: profileInfo?.lastName,
            suffix: '',
            prefix: null,
            addressLine1: profileInfo?.address?.addressLine1,
            addressLine2: profileInfo?.address?.addressLine2,
            city: profileInfo?.address?.city,
            state: profileInfo?.address?.state,
            countryCode: profileInfo?.address?.countryCode,
          },
          binData: {
            binProcessEventSuccess: 'true',
            binProcessEventTimedOut: 'false',
            binProcessEventTime: '3406',
          },
        },
      },
    ],
    referenceId: paymentDetails?.referenceId,
    transactionId: paymentDetails?.transactionId,
    browserData: {
      javascriptEnabled: 'true',
      acceptHeader: 'application/json',
    },
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().confirmSubmitUrl}`;
  return HttpService.post(apiURL, postData);
};

export const addCardDetailsAPI = (data) => {
  const intendType = `${getIntendType('payment')}`;

  let ordNum;
  let cardDetails;
  let userDetails;
  let encCardDetails;
  let paymentDetails;
  let paymentAmount;
  let profileInfo;
  let cartHeader;
  let account_No;
  let location_Code;
  let phone_No;
  let orderType;
  let orderNumberVal;
  let postData = {};
  if (isFuncComp()) {
    ordNum = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.orderDetails?.orderNumber;
    cardDetails = data.showSelectedCard ? data.showSelectedCard.cardInfo : data.showSavedCard.cardInfo;
    userDetails = data.cardAdditionalInfo;
    encCardDetails = data.showSelectedCard ? data.showSelectedCard.encCardInfo : data.showSavedCard.encCardInfo;
    paymentDetails = store.getState()?.checkout?.getCheckoutResponse?.data?.payment;
    paymentAmount = paymentDetails?.orderTotal;
    profileInfo = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.primaryUserInfo;
    cartHeader = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.cartHeader;
    account_No = cartHeader && cartHeader?.fullAccountNumber && cartHeader?.fullAccountNumber.split('-')[0];
    location_Code = cartHeader && cartHeader?.cartCreatorOrderLocationCode;
    phone_No = profileInfo && profileInfo?.address && profileInfo?.address?.phoneNumber;
    orderType = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.orderDetails?.orderType;
    orderNumberVal = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.orderDetails?.orderNumber;
  } else {
    ordNum = store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.orderNumber;
    cardDetails = data.showSelectedCard ? data.showSelectedCard.cardInfo : data.showSavedCard.cardInfo;
    userDetails = data.cardAdditionalInfo;
    encCardDetails = data.showSelectedCard ? data.showSelectedCard.encCardInfo : data.showSavedCard.encCardInfo;
    paymentDetails = store.getState()?.paymentInfo?.data;
    paymentAmount = paymentDetails?.orderTotal;
    profileInfo = store.getState()?.cartDetails?.cartDetailsJson?.primaryUserInfo;
    cartHeader = store.getState()?.cartDetails?.cartDetailsJson?.cartHeader;
    account_No = cartHeader && cartHeader?.fullAccountNumber && cartHeader?.fullAccountNumber.split('-')[0];
    location_Code = cartHeader && cartHeader?.cartCreatorOrderLocationCode;
    phone_No = profileInfo && profileInfo?.address && profileInfo?.address?.phoneNumber;
    orderType = store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.orderType;
    orderNumberVal = store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.orderNumber;
  }
  const pymentDataArray = [
    {
      paymRegisterNum: '30',
      paymentAmount,
      paymentType: 'CR',
      savedCC: !!data.showSavedCard,
      creditCardPayment: {
        cardNumber: cardDetails && maskCard(cardDetails?.creditCardNumber),
        cardExpMonth: cardDetails?.creditCardExpMonth,
        cardExpYear: cardDetails?.creditCardExpYear,
        encryptedCardData: encCardDetails?.encryptedCardData,
        encryptedCardData2: encCardDetails?.encryptedCardData2,
        cardAddressZip: cardDetails?.creditCardZip,
        encryptType: 'PIE',
        creditCardType: cardDetails?.creditCardType,
        cardAdditionalInfo: {
          firstName: userDetails?.firstName || profileInfo?.firstName,
          midInitials: '',
          lastName: userDetails?.lastName || profileInfo?.lastName,
          suffix: '',
          prefix: null,
          addressLine1: profileInfo?.address?.addressLine1,
          addressLine2: profileInfo?.address?.addressLine2,
          city: profileInfo?.address?.city,
          state: profileInfo?.address?.state,
          countryCode: intendType.includes('NSE') ? 'US' : profileInfo?.address?.countryCode,
        },
        binData: {
          binProcessEventSuccess: 'true',
          binProcessEventTimedOut: 'false',
          binProcessEventTime: '3406',
        },
      },
    },
  ];
  postData = intendType.includes('NSE')
    ? {
        skipCheckoutCall: true,
        accountNumber: '',
        action: 'lookup',
        intendType,
        mobileNumber: mobileNumber || phone_No,
        orderType: orderType || 'PS',
        meta: {
          locationCode: locationCode || location_Code,
          orderNumber: ordNum,
          regNo: '30',
          salesRep: 'ENC',
          userId: '',
        },
        paymentData: pymentDataArray,
        referenceId: paymentDetails?.referenceId || 'dbb59e8c-51b5-4f6c-8869-fe482d10bedb',
        transactionId: paymentDetails?.transactionId || '7286ff88-e7cd-4ef5-85a3-7f437f79cd5d',
        browserData: {
          javascriptEnabled: 'true',
          acceptHeader: 'application/json',
        },
      }
    : {
        skipCheckoutCall: true,
        accountNumber: account_No || '',
        accountSubNumber: '00001',
        action: 'lookup',
        intendType,
        locationCode: locationCode || location_Code,
        mobileNumber: mobileNumber || phone_No,
        orderNumber: orderNumberVal,
        orderType: orderType || 'PS',
        paymentData: pymentDataArray,
        referenceId: paymentDetails?.referenceId || 'dbb59e8c-51b5-4f6c-8869-fe482d10bedb',
        transactionId: paymentDetails?.transactionId || '7286ff88-e7cd-4ef5-85a3-7f437f79cd5d',
        browserData: {
          javascriptEnabled: 'true',
          acceptHeader: 'application/json',
        },
      };
  // https://soe-hivv-nssit3-bg.ebiz.verizon.com/paymentservice/confirmSubmit
  const apiURL = `${getSecureBaseUrl()}${apiUrls().confirmSubmitUrl}`;
  return HttpService.post(apiURL, postData);
};

export const getCartDetailsPayment = (data) => ({
  type: Constants.GET_CART_DETAILS_PAYMENT,
  data,
});

export const handle3dPaymentValidatedD2D = (data) => ({
  type: 'D2D_HANDLE_3D_PAYMENT_VALIDATED',
  data,
});

export const handle3dPaymentValidated = (data, jwt, selectedSavedCardIndex, successCallback) => ({
  type: Constants.HANDLE_3D_PAYMENT_VALIDATED,
  data,
  jwt,
  selectedSavedCardIndex,
  successCallback,
});

export const addB2ACardDetailsToAPI = () => {
  // let
  const intendType = `${getIntendType('payment')}`;
  let paymentDetails;
  let paymentAmount;
  let orderType;
  let cartHeader;
  let account_No;
  let location_Code;
  let orderNumberVal;

  if (isFuncComp()) {
    paymentDetails = store.getState()?.checkout?.getCheckoutResponse?.data?.payment;
    paymentAmount = paymentDetails?.orderTotal;
    orderType = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.orderDetails?.orderType;
    cartHeader = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.cartHeader;
    account_No = cartHeader && cartHeader?.fullAccountNumber && cartHeader?.fullAccountNumber.split('-')[0];
    location_Code = cartHeader && cartHeader?.cartCreatorOrderLocationCode;
    orderNumberVal = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.orderDetails?.orderNumber;
  } else {
    paymentDetails = store.getState()?.paymentInfo?.data;
    paymentAmount = paymentDetails?.orderTotal;
    orderType = store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.orderType;
    cartHeader = store.getState()?.cartDetails?.cartDetailsJson?.cartHeader;
    account_No = cartHeader && cartHeader?.fullAccountNumber && cartHeader?.fullAccountNumber.split('-')[0];
    location_Code = cartHeader && cartHeader?.cartCreatorOrderLocationCode;
    orderNumberVal = store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.orderNumber;
  }
  const postData = {
    accountNumber: account_No,
    action: 'update',
    intendType,
    locationCode: locationCode || location_Code,
    mobileNumber: mobileNumber || '',
    orderNumber: orderNumberVal,
    orderType: orderType || 'IS',
    skipCheckoutCall: true,
    paymentData: [
      {
        paymRegisterNum: '30',
        paymentAmount,
        paymentType: 'AC',
        savedCC: false,
        acPayment: {
          billingSystem: 'VN',
          mtnLevelCharge: true,
        },
      },
    ],
    referenceId: paymentDetails?.referenceId || 'dbb59e8c-51b5-4f6c-8869-fe482d10bedb',
    transactionId: paymentDetails?.transactionId || '7286ff88-e7cd-4ef5-85a3-7f437f79cd5d',
  };
  // https://soe-hivv-nssit3-bg.ebiz.verizon.com/paymentservice/confirmSubmit
  const apiURL = `${getSecureBaseUrl()}${apiUrls().confirmSubmitUrl}`;
  return HttpService.post(apiURL, postData);
};

/* handle Cardinal api Call */

export const handle3dPaymentValidatedAPI = (action) => {
  const savedCardDetails = store.getState()?.paymentInfo?.savedcardInfo;
  const cardDetails = savedCardDetails?.showSelectedCard?.cardInfo || '';
  const encCardDetails = savedCardDetails?.showSelectedCard?.encCardInfo || '';
  const userDetails = savedCardDetails?.cardAdditionalInfo || '';

  let paymentDetails;
  let paymentAmount;
  let cartDetails;
  let primaryUserInfo;
  let orderDetailsView;
  let cartHeader;
  let account_No;
  let phone_No;
  let ordNum;

  if (isFuncComp()) {
    paymentDetails = store.getState()?.checkout?.getCheckoutResponse?.data?.payment;
    paymentAmount = paymentDetails?.orderTotal;
    cartDetails = store.getState()?.checkout?.getCheckoutResponse?.data?.cart || '';
    primaryUserInfo =
      store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.lineDetails?.lineInfo?.newline1?.serviceInfo?.primaryUserInfo || '';
    orderDetailsView = cartDetails?.orderDetails || '';
    cartHeader = store.getState()?.checkout?.getCheckoutResponse?.data?.cart?.cartHeader;
    account_No = cartHeader && cartHeader?.fullAccountNumber && cartHeader?.fullAccountNumber.split('-')[0];
    phone_No = primaryUserInfo?.address?.phoneNumber;
    ordNum = cartDetails?.orderDetails?.orderNumber;
  } else {
    paymentDetails = store.getState()?.paymentInfo?.data;
    paymentAmount = paymentDetails?.orderTotal;
    cartDetails = store.getState()?.cartDetails?.cartDetailsJson || '';
    primaryUserInfo = cartDetails?.primaryUserInfo || '';
    orderDetailsView = cartDetails?.orderDetailsView || '';
    cartHeader = store.getState()?.cartDetails?.cartDetailsJson?.cartHeader;
    account_No = cartHeader && cartHeader?.fullAccountNumber && cartHeader?.fullAccountNumber.split('-')[0];
    phone_No = primaryUserInfo?.address?.phoneNumber;
    ordNum = store.getState()?.cartDetails?.cartDetailsJson?.orderDetailsView?.orderNumber;
  }
  let ExtendedData = {};
  ExtendedData = action?.data?.Payment?.ExtendedData || {};
  const intendType = `${getIntendType()}`;
  const meta = {
    locationCode: `${locationCode}`,
    orderNumber: ordNum,
  };
  const meta1 = {
    locationCode: `${locationCode}`,
    orderNumber: ordNum,
    regNo: '30',
    salesRep: 'ENC',
    userId: '',
  };
  const postData = {
    meta: intendType.includes('NSE') ? meta1 : meta,
    action: 'update',
    mobileNumber: mobileNumber || phone_No,
    accountNumber: account_No,
    orderType: orderDetailsView && orderDetailsView.orderType ? orderDetailsView.orderType : '',
    intendType: `${getIntendType()}`,
    paymentData: [
      {
        paymRegisterNum: '30',
        paymentAmount,
        paymentType: 'CR',
        savedCC: false,
        creditCardPayment: {
          cardNumber: cardDetails && maskCard(cardDetails.creditCardNumber),
          cardExpMonth: cardDetails.creditCardExpMonth,
          cardExpYear: cardDetails.creditCardExpYear,
          encryptedCardData: encCardDetails.encryptedCardData,
          encryptedCardData2: encCardDetails.encryptedCardData2,
          cardAddressZip: cardDetails.creditCardZip,
          encryptType: 'PIE',
          creditCardType: cardDetails.creditCardType,
          cardAdditionalInfo: {
            firstName: userDetails.firstName,
            midInitials: '',
            lastName: userDetails.lastName,
            suffix: '',
            prefix: null,
            addressLine1: primaryUserInfo?.address?.addressLine1 || '',
            addressLine2: '',
            city: primaryUserInfo?.address?.city || '',
            state: primaryUserInfo?.address?.state || '',
            countryCode: primaryUserInfo?.address?.countryCode,
          },
          binData: {
            binProcessEventSuccess: 'true',
            binProcessEventTimedOut: 'false',
            binProcessEventTime: '3406',
            eCommerceIndicator: ExtendedData.ECIFlag,
            authenticationValue: ExtendedData.CAVV,
            secureTxnId: ExtendedData.XID,
            secureJwtToken: action.jwt,
          },
        },
      },
    ],
    referenceId: paymentDetails?.referenceId || 'dbb59e8c-51b5-4f6c-8869-fe482d10bedb',
    transactionId: paymentDetails?.transactionId || '7286ff88-e7cd-4ef5-85a3-7f437f79cd5d',
  };
  const apiURL = `${getSecureBaseUrl()}${apiUrls().handle3DCardinalResponse}`;
  return HttpService.post(apiURL, postData);
};

//Action to get paypal Details from retrieveCart

export const getPaypalDetails = (data) => ({
  type: Constants.GET_PAYPAL_DETAILS_FROM_CART,
  data,
});

// To show Error Notification

export const showErrorNotification = (message) => ({
  type: Constants.SHOW_NOTIFICATION,
  data: message,
});

// tp remove notification from the page
export const removeErrorNotification = () => ({
  type: Constants.HIDE_NOTIFICATION,
});
